import { useCallback, useEffect, useMemo, useState } from 'react';

const PENDING_STATUSES = new Set(['queued', 'running']);
const VISIBLE_STATUSES = new Set(['queued', 'running', 'success', 'stale', 'failed']);

export function isOperationDialogStatus(status) {
  return VISIBLE_STATUSES.has(status);
}

export function useOperationDialogVisibility(status) {
  const [active, setActive] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (PENDING_STATUSES.has(status)) {
      setActive(true);
      setDismissed(false);
    }
    if (!status) {
      setActive(false);
      setDismissed(false);
    }
  }, [status]);

  const begin = useCallback(() => {
    setActive(true);
    setDismissed(false);
  }, []);

  const close = useCallback(() => {
    setDismissed(true);
    setActive(false);
  }, []);

  const open = useMemo(
    () => active && isOperationDialogStatus(status) && !dismissed,
    [active, dismissed, status],
  );

  return useMemo(() => ({
    active,
    begin,
    close,
    open,
  }), [active, begin, close, open]);
}
